import { render, staticRenderFns } from "./storeManagement.vue?vue&type=template&id=a4613ee2&scoped=true"
import script from "./storeManagement.vue?vue&type=script&lang=js"
export * from "./storeManagement.vue?vue&type=script&lang=js"
import style0 from "./storeManagement.vue?vue&type=style&index=0&id=a4613ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4613ee2",
  null
  
)

export default component.exports